import { svg } from "lit";
const icon = svg `<path d="M5.68766 16.1342L6.83988 11.3057L3.01782 8.05735L8.03059 7.62147L10.0001 3.06543L11.9696 7.64231L16.9824 8.05735L13.1603 11.3057L14.3126 16.1342L10.0001 13.5733L5.68766 16.1342Z" fill="currentColor"/>`;
export default icon;
